"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const mobx_1 = require("mobx");
const getQuickPayDetail_1 = __importDefault(require("../../clients/quickPay/getQuickPayDetail"));
const API_STATE_1 = __importDefault(require("../../constants/app/API_STATE"));
const DEFAULT_CURRENCY_1 = __importDefault(require("../../constants/date/DEFAULT_CURRENCY"));
const QUICK_PAY_API_ERROR_CODES_1 = __importDefault(require("../../constants/errorCodes/QUICK_PAY_API_ERROR_CODES"));
const PAYMENT_STATUS_1 = __importDefault(require("../../constants/payment/PAYMENT_STATUS"));
const formatPriceValue_1 = __importDefault(require("../../factories/utils/common/formatPriceValue"));
const mapInitialStateToStoreState_1 = __importDefault(require("../../utils/store/mapInitialStateToStoreState"));
/**
 * Quick Pay Detial by ID Domain Store
 */
class QuickPayDetailStore {
    constructor(initialState, $env) {
        this.data = {};
        this.apiState = API_STATE_1.default.INITIAL;
        this.errorData = {};
        /**
         * Fetches quick pay details data from backend
         * @param errorHandler {function}
         */
        this.fetch = (0, mobx_1.flow)(function* (trackId, errorHandler) {
            try {
                this.apiState = API_STATE_1.default.LOADING;
                this.data = {};
                this.errorData = {};
                const response = yield (0, getQuickPayDetail_1.default)(trackId);
                // 200 http codes
                this.onSuccess(response);
            }
            catch (err) {
                // all other http codes
                this.onError(err, errorHandler);
            }
        });
        /**
         * on success callback
         * @param data
         */
        this.onSuccess = (data) => {
            this.data = data;
            this.apiState = API_STATE_1.default.SUCCESS;
        };
        /**
         * on error callback
         * @param err
         * @param errorHandler
         */
        this.onError = (err, errorHandler) => {
            this.apiState = API_STATE_1.default.FAILED;
            // when a request is cancelled, Axios promise is rejected
            if (err.response) {
                const errResponse = err.response;
                const { data, status } = errResponse;
                // stores axios error info in observable
                this.errorData = {
                    data,
                    status,
                };
                if (errorHandler) {
                    errorHandler(errResponse);
                }
            }
        };
        /**
         * Map initial state to store state
         * @param initialState
         */
        this.updateInitialState = (initialState) => {
            (0, mapInitialStateToStoreState_1.default)(this, initialState);
        };
        this.$env = $env;
        this.updateInitialState(initialState);
    }
    /**
     * Returns the loading status
     * @returns {Boolean}
     */
    get isLoading() {
        return this.apiState === API_STATE_1.default.LOADING;
    }
    /**
     * Returns true if API fetch was success
     * @returns {Boolean}
     */
    get isSuccess() {
        return this.apiState === API_STATE_1.default.SUCCESS;
    }
    /**
     * Returns true if API fetch has failed
     * @returns {Boolean}
     */
    get hasFailed() {
        return this.apiState === API_STATE_1.default.FAILED;
    }
    /**
     * Returns true if booking is completed.
     */
    get initiated() {
        return (0, get_1.default)(this.data, 'initiated', false);
    }
    /**
     * Returns booking pay status
     * @returns {String}
     */
    get status() {
        return (0, get_1.default)(this.data, 'status', '');
    }
    /**
     * Returns customer name
     * @returns {String}
     */
    get customerName() {
        return (0, get_1.default)(this.data, 'customerName', '');
    }
    /**
     * Returns customer identifier
     * @returns {String}
     */
    get customerIdentifier() {
        return (0, get_1.default)(this.data, 'customerIdentifier', '');
    }
    /**
     * Returns customer identifier type
     * @returns {String}
     */
    get customerIdentifierType() {
        return (0, get_1.default)(this.data, 'customerIdentifierType', '');
    }
    /**
     * Returns paid by
     * @returns {String}
     */
    get paidThrough() {
        return (0, get_1.default)(this.data, 'paidThrough', '');
    }
    /**
     * Returns pay type
     * @returns {String}
     */
    get payType() {
        return (0, get_1.default)(this.data, 'payType', '');
    }
    /**
     * Returns card number
     * @returns {String}
     */
    get card() {
        return (0, get_1.default)(this.data, 'card', '');
    }
    /**
     * Returns currency
     * @returns {String}
     */
    get currency() {
        return (0, get_1.default)(this.data, 'currency', DEFAULT_CURRENCY_1.default);
    }
    /**
     * Returns quick pay price
     * @returns {String}
     */
    get totalPrice() {
        const amount = (0, get_1.default)(this.data, 'amount', '');
        return (0, formatPriceValue_1.default)(amount, this.currency);
    }
    /**
     * Returns remarks
     * @returns {String}
     */
    get remarks() {
        return (0, get_1.default)(this.data, 'remarks', '');
    }
    /**
     * Returns error code
     * @returns {String}
     */
    get errorCode() {
        return (0, get_1.default)(this.errorData, 'data.code', '');
    }
    /**
     * Returns payment id as payment reference
     * @returns {String}
     */
    get paymentId() {
        return (0, get_1.default)(this.data, 'paymentId', '');
    }
    /**
     * Returns booking reference number
     * @returns {String}
     */
    get referenceNumber() {
        return (0, get_1.default)(this.data, 'referenceNo', '');
    }
    /**
     * Returns ture if payment is failed.
     * @returns {Boolean}
     */
    get isPaymentFailed() {
        return this.initiated && this.status === PAYMENT_STATUS_1.default.FAILED;
    }
    /**
     * Returns payment fialed code.
     * @returns {Boolean}
     */
    get paymentFailedCode() {
        return (0, get_1.default)(this.data, 'failure.code', '');
    }
    /**
     * Returns ture if payment link is expired.
     * @returns {Boolean}
     */
    get isPaymentExpired() {
        return (this.hasFailed && this.errorCode === QUICK_PAY_API_ERROR_CODES_1.default.PY3013);
    }
    /**
     * Returns ture if payment link is success.
     * @returns {Boolean}
     */
    get isPaymentSuccess() {
        return (this.isSuccess && this.initiated && this.status === PAYMENT_STATUS_1.default.SUCCESS);
    }
    /**
     * Returns ture if payment link not found.
     * @returns {Boolean}
     */
    get isPageNotFound() {
        return (this.hasFailed && this.errorCode === QUICK_PAY_API_ERROR_CODES_1.default.PY3001);
    }
    /**
     * Returns error description.
     * @returns {string}
     */
    get errerDesc() {
        return (0, get_1.default)(this.errorData, 'data.desc', '');
    }
}
__decorate([
    mobx_1.observable
], QuickPayDetailStore.prototype, "data", void 0);
__decorate([
    mobx_1.observable
], QuickPayDetailStore.prototype, "apiState", void 0);
__decorate([
    mobx_1.observable
], QuickPayDetailStore.prototype, "errorData", void 0);
__decorate([
    mobx_1.computed
], QuickPayDetailStore.prototype, "isLoading", null);
__decorate([
    mobx_1.computed
], QuickPayDetailStore.prototype, "isSuccess", null);
__decorate([
    mobx_1.computed
], QuickPayDetailStore.prototype, "hasFailed", null);
__decorate([
    mobx_1.computed
], QuickPayDetailStore.prototype, "initiated", null);
__decorate([
    mobx_1.computed
], QuickPayDetailStore.prototype, "status", null);
__decorate([
    mobx_1.computed
], QuickPayDetailStore.prototype, "customerName", null);
__decorate([
    mobx_1.computed
], QuickPayDetailStore.prototype, "customerIdentifier", null);
__decorate([
    mobx_1.computed
], QuickPayDetailStore.prototype, "customerIdentifierType", null);
__decorate([
    mobx_1.computed
], QuickPayDetailStore.prototype, "paidThrough", null);
__decorate([
    mobx_1.computed
], QuickPayDetailStore.prototype, "payType", null);
__decorate([
    mobx_1.computed
], QuickPayDetailStore.prototype, "card", null);
__decorate([
    mobx_1.computed
], QuickPayDetailStore.prototype, "currency", null);
__decorate([
    mobx_1.computed
], QuickPayDetailStore.prototype, "totalPrice", null);
__decorate([
    mobx_1.computed
], QuickPayDetailStore.prototype, "remarks", null);
__decorate([
    mobx_1.computed
], QuickPayDetailStore.prototype, "errorCode", null);
__decorate([
    mobx_1.computed
], QuickPayDetailStore.prototype, "paymentId", null);
__decorate([
    mobx_1.computed
], QuickPayDetailStore.prototype, "referenceNumber", null);
__decorate([
    mobx_1.computed
], QuickPayDetailStore.prototype, "isPaymentFailed", null);
__decorate([
    mobx_1.computed
], QuickPayDetailStore.prototype, "paymentFailedCode", null);
__decorate([
    mobx_1.computed
], QuickPayDetailStore.prototype, "isPaymentExpired", null);
__decorate([
    mobx_1.computed
], QuickPayDetailStore.prototype, "isPaymentSuccess", null);
__decorate([
    mobx_1.computed
], QuickPayDetailStore.prototype, "isPageNotFound", null);
__decorate([
    mobx_1.computed
], QuickPayDetailStore.prototype, "errerDesc", null);
__decorate([
    mobx_1.action.bound
], QuickPayDetailStore.prototype, "onSuccess", void 0);
__decorate([
    mobx_1.action.bound
], QuickPayDetailStore.prototype, "onError", void 0);
__decorate([
    mobx_1.action.bound
], QuickPayDetailStore.prototype, "updateInitialState", void 0);
exports.default = QuickPayDetailStore;
